import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class SubscribeService {
    private subject = new Subject<any>();
    private DeleteSubject = new Subject<any>();
    private clientWalkInGridSubject = new Subject<any>();
    private testingBillListGridSubject = new Subject<any>();
    private challanOutListGridSubject = new Subject<any>();
    private challanInListGridSubject = new Subject<any>();
    private salesBillentryGridSubject = new Subject<any>();
    private tCOutListGridSubject = new Subject<any>();
    private transferInListGridSubject = new Subject<any>();
    private getServiceWalkInList = new Subject<any>();
    private getTestingList = new Subject<any>();

    private setServiceData = new Subject<any>();

    private appointmentGridSubject = new Subject<any>();
    private cashOutListGridSubject = new Subject<any>();
    private cashInListGridSubject = new Subject<any>();
    private expenseListGridSubject = new Subject<any>();
	private homeInGridSubject = new Subject<any>();
	private newPurchaseReturnListGridSubject = new Subject<any>();


    //TO ADD NEW TAB
    subScribeTabID(tabGroup: string, tabid: string, params: object,
        tabParams: string) {
        this.subject.next({
            tabGroup: tabGroup, tabid: tabid, params:
                params, tabParams: tabParams
        });
    }
    clearTabID() {
        this.subject.next();
    }
    publishTabID(): Observable<any> {
        return this.subject.asObservable();
    }
    //TO DELETE TAB
    subScribeDeleteActiveTab() {
        this.DeleteSubject.next();
    }
    publishDeleteTab(): Observable<any> {
        return this.DeleteSubject.asObservable();
    }

    //TO RELOAD CLIENT WALKIN LIST GRID
    subReloadClientWalkInGrid() {
        this.clientWalkInGridSubject.next();
    }
    publishReloadClientWalkInGrid(): Observable<any> {
        return this.clientWalkInGridSubject.asObservable();
    }
    subReloadHomeGrid() {
        this.homeInGridSubject.next();
    }
    publishReloadHomeGrid(): Observable<any> {
        return this.homeInGridSubject.asObservable();
    }


    //TO RELOAD TESTING BILL LIST GRID
    subReloadTestingBillListGrid() {
        this.testingBillListGridSubject.next();
    }
    publishReloadTestingBillListGrid(): Observable<any> {
        return this.testingBillListGridSubject.asObservable();
    }
    //TO RELOAD CHALLAN OUT LIST GRID
    subReloadChallanOutListGrid() {
        this.challanOutListGridSubject.next();
    }
    publishReloadChallanOutListGrid(): Observable<any> {
        return this.challanOutListGridSubject.asObservable();
    }
    //TO RELOAD CHALLAN IN LIST GRID
    subReloadChallanInListGrid() {
        this.challanInListGridSubject.next();
    }
    publishReloadChallanInListGrid(): Observable<any> {
        return this.challanInListGridSubject.asObservable();
    }
    //TO RELOAD SALES BILL ENTRY LIST GRID
    subReloadSalesBillentryListGrid() {
        this.salesBillentryGridSubject.next();
    }
    publishReloadSalesBillentryListGrid(): Observable<any> {
        return this.salesBillentryGridSubject.asObservable();
    }
    subReloadServiceGrid() {
        this.getServiceWalkInList.next();
    }
    publishReloadServiceGrid(): Observable<any> {
        return this.getServiceWalkInList.asObservable();
    }
    subReloadServiceTestGrid() {
        this.getTestingList.next();
    }
    publishReloadServiceTestGrid(): Observable<any> {
        return this.getTestingList.asObservable();
    }




    //TO RELOAD TRANSFER CHALLAN LIST GRID
    subReloadTcOutGrid() {
        this.tCOutListGridSubject.next();
    }
    publishReloadTcOutGrid(): Observable<any> {
        return this.tCOutListGridSubject.asObservable();
    }
    //TO RELOAD TRANSFER IN LIST GRID
    subReloadTransferInListGrid() {
        this.transferInListGridSubject.next();
    }
    publishReloadTransferInListGrid(): Observable<any> {
        return this.transferInListGridSubject.asObservable();
    }


    // TO SET SERVICE CLIENT DATA AFTER SAVED
    setServiceClient(data) {
        this.setServiceData.next(data);
    }
    publishSetClient(): Observable<any> {
        return this.setServiceData.asObservable();
    }

    //TO RELOAD APPOINTMENT LIST GRID
    subReloadAppointmentGrid() {
        this.appointmentGridSubject.next();
    }
    publishReloadAppointmentGrid(): Observable<any> {
        return this.appointmentGridSubject.asObservable();
    }

    //TO RELOAD CASH OUT LIST GRID
    subReloadCashOutGrid() {
        this.cashOutListGridSubject.next();
    }
    publishReloadCashOutGrid(): Observable<any> {
        return this.cashOutListGridSubject.asObservable();
    }

    //TO RELOAD Cash In LIST GRID
    subReloadCashInGrid() {
        this.cashInListGridSubject.next();
    }
    publishReloadCashInGrid(): Observable<any> {
        return this.cashInListGridSubject.asObservable();
    }

    //TO RELOAD EXPENSE LIST GRID
    subReloadExpenseGrid() {
        this.expenseListGridSubject.next();
    }
    publishReloadExpenseGrid(): Observable<any> {
        return this.expenseListGridSubject.asObservable();
    }

    //TO RELOAD NEW PURCHASE RETURN LIST GRID
    subReloadNewPurchaseReturnListGrid() {
        this.newPurchaseReturnListGridSubject.next();
    }
    publishReloadNewPurchaseReturnListGrid(): Observable<any> {
        return this.newPurchaseReturnListGridSubject.asObservable();
    }

}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/subscribe.service.ts